import { SpinnerSize } from './types';

export const styles = {
  sizes: {
    sm: 'tw-h-4 tw-w-4',
    md: 'tw-h-5 tw-w-5',
    lg: 'tw-h-6 tw-w-6',
  } as Record<SpinnerSize, string>,
};
